import React, { useState } from 'react';
import { connect } from 'react-redux';
import GLOBAL_STYLES from '../styles';
import {
  getHoursMinutes,
  convertTimestampDate, getWeightUom,
} from '../helpers/misc';
import { app } from '../state/actions';
import { Form, Button } from 'react-bootstrap';
import DatePicker from 'react-datepicker';


const mapStateToProps = state => ({
  colorScheme: state.main.colorScheme,
  openMachineSelectedJob: state.app.openMachineSelectedJob,
  insertJobType: state.app.insertJobType,
});

const mapDispatchToProps = dispatch => ({
  updateOpenMachineSelectedJob: payload => dispatch(app.updateOpenMachineSelectedJob(payload)),
});

const ReleasedJob = props => {
  const {
    jobArr,
    colorScheme,
    updateOpenMachineSelectedJob,
    openMachineSelectedJob,
    index,
    insertJobType,
    timeNow,
    insertJob,
  } = props;
  const [staticDate, setStaticDate] = useState(null);
  const isSelected = openMachineSelectedJob != null && openMachineSelectedJob === index && insertJobType === 'DYNAMIC';
  
  const totalMaterials = jobArr?.length ? [...jobArr.reduce((totals, job) => {
    if(!job.partMaterials) return totals;
    job.partMaterials.forEach(material => {
      let matTotal = totals.get(material.materialNumber) ?? 0;
      matTotal += material.requiredQuantity;
      totals.set(material.materialNumber, matTotal);
    });
    return totals;
  }, new Map()).entries()] : [];
  const totalContainers = jobArr?.length ? jobArr.reduce((total, job) => total + (!job.containerQuantity ? 0 : Math.ceil(job.startQty / job.containerQuantity)), 0) : 0;
  const weightUom = getWeightUom(jobArr?.[0]?.jobLocator);
  
  return (
    <div
      style={{
        ...styles.container,
        backgroundColor: isSelected ?
          GLOBAL_STYLES.CONSTANTS.orangeColor :
          jobArr[0].unit === 'RD' ?
            GLOBAL_STYLES.CONSTANTS.yellowColor :
            GLOBAL_STYLES.CONSTANTS.greenColor,
        borderColor: GLOBAL_STYLES[colorScheme].fgColor,
        cursor: insertJobType === 'DYNAMIC' ? 'pointer' : 'default',
      }}
      onClick={insertJobType === 'DYNAMIC' ?
        isSelected ?
          () => updateOpenMachineSelectedJob(null) :
          () => updateOpenMachineSelectedJob(index) :
        null
      }
    >
      <p style={styles.text}>
        <span style={styles.title}>
          {`JOB${jobArr.length > 1 ? 'S' : ''}: `}
        </span>
        {jobArr.map(j => j.jobNumber).join(' & ')}
      </p>
      <p style={styles.text}>
        <span style={styles.title}>
          {`TOOL: `}
        </span>
        {`${jobArr[0].toolNumber}${jobArr[0].toolLocation ? ` (${jobArr[0].toolLocation})` : ''}`}
      </p>
      {jobArr[0].lastPmDate ?
        <p style={styles.text}>
        <span style={styles.title}>
          {`LAST PM: `}
        </span>
          {convertTimestampDate(jobArr[0].lastPmDate)}
        </p> :
        null
      }
      {jobArr[0].pmCycle ?
        <p style={styles.text}>
        <span style={styles.title}>
          {`PM CYCLE: `}
        </span>
          {`${(((jobArr[0].cycleCount ? jobArr[0].cycleCount : 0) / jobArr[0].pmCycle) * 100).toFixed(0)}%`}
        </p> :
        null
      }
      <p style={styles.text}>
        <span style={styles.title}>
          {`PART${jobArr.length > 1 ? 'S' : ''}: `}
        </span>
        {jobArr.map(j => j.partNumber).join(' & ')}
      </p>
      <p style={styles.text}>
        <span style={styles.title}>
          {`QTY: `}
        </span>
        {jobArr[0].startQty}
      </p>
      <p style={styles.text}>
        <span style={styles.title}>
          {`MATERIALS: `}
        </span>
        {totalMaterials?.length ? totalMaterials.map(([materialNumber, total]) => `${materialNumber} (${Math.round(total)} ${weightUom})`).join(', ') : null}
      </p>
      <p style={styles.text}>
        <span style={styles.title}>
          {`CONTAINERS: `}
        </span>
        {jobArr?.[0]?.containerPartNumber ? `${jobArr?.[0]?.containerPartNumber} (${totalContainers})` : null}
      </p>
      <p style={styles.text}>
        <span style={styles.title}>
          {`RUNTIME: `}
        </span>
        {getHoursMinutes(jobArr[0].stdRunTime)}
      </p>
      <p style={styles.text}>
        <span style={styles.title}>
          {`REQUIRED END: `}
        </span>
        {convertTimestampDate(jobArr[0].scheduledCompletionDate)}
      </p>
      {
        insertJobType === 'STATIC' ?
          <>
            <Form.Group
              style={{
                display: 'flex',
                flexDirection: 'column',
                marginBottom: 5,
              }}
            >
              <DatePicker
                selected={staticDate}
                onChange={date => setStaticDate(date)}
                minDate={new Date()}
                isClearable
                showTimeSelect
                dateFormat="Pp"
                timeIntervals={15}
                placeholderText="Select start date..."
                className="form-control form-control-sm"
                onClick={e => e.stopPropagation()}
              />
            </Form.Group>
            <Button
              variant="danger"
              size="sm"
              onClick={() => {
                insertJob(index, staticDate.getTime());
                setStaticDate(null);
              }}
              disabled={staticDate == null || staticDate.getTime() < timeNow}
            >
              <i
                className="fa fa-plus fa-lg"
                style={{ color: GLOBAL_STYLES.CONSTANTS.white }}
              />
            </Button>
          </> :
          null
      }
    </div>
  );
};

const styles = {
  container: {
    userSelect: 'none',
    padding: 5,
    margin: 5,
    marginBottom: 0,
    borderRadius: 10,
    borderWidth: 1,
    borderStyle: 'solid',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
  },
  title: {
    fontWeight: 'bold',
  },
  text: {
    margin: 0,
    padding: 0,
  },
};

export default connect(mapStateToProps, mapDispatchToProps)(ReleasedJob);